/*!
 * (v) eachOnce v20190206.1515
 * Iterate through elements once. Useful for reinitializing
 */
function eachOnce(t,e,n){for(var c=e+"-initialized",i=document.querySelectorAll(t+":not(["+c+"])"),l=0;l<i.length;l++)i[l].setAttribute(c,""),"function"==typeof n&&n.call(i[l],l,i[l])}

window.addEventListener('load', function() {
    eachOnce('.c-elections2', 'c-elections2', function(index, root) {
        var table = root.querySelector('.c-elections2-table');
        var inner = root.querySelector('.c-elections2-inner');
        var cell = table.querySelector('tbody td');
        var root_width;
        var table_width;
        var cell_width;
        var range = table_width - root_width;

        var calculate = function() {
            root_width = root.offsetWidth;
            table_width = table.offsetWidth;
            cell_width = cell.offsetWidth;
            range = table_width - root_width;
        };

        root.addEventListener('click', function() {
            if(event.target.matches('[data-nav]')){
                calculate();
                if (range > 0) {
                    var forward = event.target.matches('[data-next]');
                    var current = Math.floor(inner.scrollLeft / cell_width);
                    var next = (current + (forward ? 1 : -1)) * cell_width;
                    next = Math.max(Math.min(next,range),0);
                    inner.scrollLeft = next;
                };
            }
        });
    });
});

/*
 * (v) Select (v.2012.01.27)
 * Custom select engine
 */
(function($){$.fn.vSelect=function(options){var settings={'wrap':false,'wrapclass':'select'};return this.each(function(){if(options)$.extend(settings,options);var $select=$(this);if(settings.wrap)$select.wrap('<span class="'+settings.wrapclass+'"></span>');$root=$select.closest('.'+settings.wrapclass);var $text=$('<span aria-hidden="true"></span>').insertBefore($select);var update=function(){var $selected=$select.find('option:selected');if($selected.size()===0)$selected=$select.find('option:eq(0)');$text.text($selected.text());};$select.bind({change:update,keyup:update,mouseenter:function(){$root.addClass('over');},mouseleave:function(){$root.removeClass('over');},focus:function(){$root.addClass('focus');},blur:function(){$root.removeClass('focus');}});update();});};})(jQuery);
/*
 * (v) Compact labels plugin (v20110124)
 * Takes one option: labelOpacity [default: true] set to false to disable label opacity change on empty input focus
 */
(function($) {
    $.fn.compactize = function(options) {
        var defaults = {
            labelOpacity:true
        };

        options = $.extend(defaults, options);

        return this.each(function() {
            var label = $(this),
            input = $('#' + label.attr('for'));

            if (input.val() === '') {
                label.show();
            } else {
                label.hide();
            }

            input.focus(function() {
                if (options.labelOpacity) {
                    if (input.val() === '') {
                        label.css('opacity','0.5');
                    }
                } else {
                    label.hide();
                }
            });

            input.keydown(function() {
                label.hide();
            });

            input.blur(function() {
                if (input.val() === '') {
                    label.show();

                    if (options.labelOpacity) {
                        label.css('opacity',1);
                    }
                }
            });

            window.setInterval(function() {
                if (input.val() !== '') {
                    label.hide();
                }
            }, 50);
        });
    };
})(jQuery);

/*
 * Scripts
 *
 */
$(document).ready(function () {
    "use strict";

    var Engine = {
        utils: {
            links: function () {
                $('a[rel*="external"]').click(function (e) {
                    e.preventDefault();
                    window.open($(this).attr('href'));
                });
            }
        },
        forms: {
            fields: function () {
                $('.w6 label, .w47 > .two p label, .w4 > .login p label, .cl1 .filter .wrap .fields p.input label, .form-a p label.in, .w53 .fields .wrap p label:first-child, .w102 .fields .wrap p label:first-child, .w116 .search label').show().compactize();
                $('.select-a select').vSelect();
                $('.form-a .file input').change(function () {
                    $(this).prev('label').find('span').html($(this).val()).css('text-indent', '0');
                });

                if (typeof $.fn.selectize != 'undefined') $('.selectize-a select').selectize();

                $('select.urljump').change(function () {
                    location.href = this.value;
                });

            }
        }
    };

    Engine.utils.links();
    Engine.forms.fields();
});
